/**
 * The max file size we accept for upload.
 */
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
